import { render, staticRenderFns } from "./SaveModal.vue?vue&type=template&id=0490e2ab&scoped=true&"
import script from "./SaveModal.vue?vue&type=script&lang=js&"
export * from "./SaveModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveModal.vue?vue&type=style&index=0&id=0490e2ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490e2ab",
  null
  
)

export default component.exports